import AuthHero from './AuthHero';

export default AuthHero;
